export default __webpack_public_path__ + "static/media/photo-button.f7cf2041.svg";